import QueryBuilder from 'utils/fieldTypes/QueryBuilder'

export default class SelectQueryBuilder extends QueryBuilder {
  filterTypes = ['is', 'is_not', 'exists', 'exists_not']
}
